export const OPERATIONAL_REPORT_TYPE = 'operational';
export const REGISTRY_REPORT_TYPE = 'registry';
export const BILL_DETAILS_REPORT_TYPE = 'billDetails';
export const CLIENT_KPI_REPORT_TYPE = 'clientKpi';
export const CARRIER_KPI_REPORT_TYPE = 'carrierKpi';
export const SHIPPINGS_KPI_REPORT_TYPE = 'shippingsKpi';
